import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {Master} from '../../../../../admin/models/master.interface';
import {FormBuilder, FormControl} from '@angular/forms';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {Countries} from '../../../../../admin/models/countries.interface';
import {REGIONS} from '../../../../../constants/constants';
import {setFormValuesFromQueryParams} from '../../../../utils/filters-utils';
import {ActivatedRoute} from '@angular/router';
import {MatOption} from '@angular/material/core';

@Component({
  selector: 'app-operations-vs-overhead-filters',
  templateUrl: './operations-vs-overhead-filters.component.html',
  styleUrls: ['./operations-vs-overhead-filters.component.scss']
})
export class OperationsVsOverheadFiltersComponent implements OnInit, OnChanges {

  @ViewChild('allSelected') private allSelected!: MatOption;

  regions = REGIONS;

  @Input()
  years!: number[];
  @Input()
  collectionStreams!: Master[];
  @Input()
  countries!: Countries[];

  searchForm = this.formBuilder.group({
    year: [''],
    collectionStreams: [''],
    detailLevel: [],
    b2bB2c: [],
    member: [],
    region: [''],
    countries: [''],
    order: [],
    displayUnits: [''],
  });

  get yearControl(): FormControl {
    return this.searchForm.get('year') as FormControl;
  }
  get collectionStreamsControl(): FormControl {
    return this.searchForm.get('collectionStreams') as FormControl;
  }
  get detailLevelControl(): FormControl {
    return this.searchForm.get('detailLevel') as FormControl;
  }
  get b2bB2cControl(): FormControl {
    return this.searchForm.get('b2bB2c') as FormControl;
  }
  get memberControl(): FormControl {
    return this.searchForm.get('member') as FormControl;
  }
  get regionControl(): FormControl {
    return this.searchForm.get('region') as FormControl;
  }
  get countriesControl(): FormControl {
    return this.searchForm.get('countries') as FormControl;
  }
  get orderControl(): FormControl {
    return this.searchForm.get('order') as FormControl;
  }

  @Output()
  search: EventEmitter<ChartsSearchInterface> = new EventEmitter<ChartsSearchInterface>();

  constructor(private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.yearControl.setValue(this.years[0]);
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.collectionStreams?.length) {
      if (!this.collectionStreamsControl.value || this.collectionStreamsControl.value.length === this.collectionStreams.length) {
        if (this.allSelected) {
          this.allSelected.select();
        }
        this.collectionStreamsControl
          .patchValue([...this.collectionStreams.map(item => item.id.toString()), 0]);
      }
    }
  }

  handleSubmit(): void {
    const search: ChartsSearchInterface = {
      startYear: this.yearControl.value,
      categories: this.collectionStreamsControl.value,
      detailLevel: this.detailLevelControl.value,
      b2bB2c: this.b2bB2cControl.value,
      member: this.memberControl.value,
      region: this.regionControl.value,
      countries: this.countriesControl.value,
      order: this.orderControl.value,
      displayUnits: this.searchForm.controls.displayUnits.value,
    };
    this.search.emit(search);
    if (this.collectionStreamsControl.value?.length === this.collectionStreams?.length) {
      this.allSelected.select();
    }
  }

  clean(): void {
    this.yearControl.setValue(this.years[0]);
    this.collectionStreamsControl.reset();
    this.detailLevelControl.reset();
    this.b2bB2cControl.reset();
    this.memberControl.reset();
    this.regionControl.reset();
    this.countriesControl.reset();
    this.orderControl.setValue(null);
    this.searchForm.controls.displayUnits.reset();
    this.search.emit({startYear: this.years[0], displayUnits: ''});
  }

  togglePerOne(): void {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return;
    }
    if (this.collectionStreamsControl.value.length === this.collectionStreams.length) {
      this.allSelected.select();
    }
  }

  toggleAllSelection(): void {
    if (this.allSelected.selected) {
      this.collectionStreamsControl
        .patchValue([...this.collectionStreams.map(item => item.id.toString()), 0]);
    } else {
      this.collectionStreamsControl.patchValue([]);
    }
  }

}
